import { ActivityIndicator } from 'react-native';
import React from 'react';
import Constants from './../constants';

export default function Spinner({ size, color = Constants.colors.primary, style = {} }: { size?: number, color?: string, style?: object }): JSX.Element {
  return (
    <ActivityIndicator size={size} style={style} color={color} />
  );
}
